<template>
    <div class="dropdown"
         v-on-clickaway="unfocus">
        <b-form-input
                ref="dropdowninput" v-model.trim="inputValue"
                class="dropdown-input"
                type="text"
                placeholder="Căutare"

                @click="focus"
                @keydown.enter="handleEnter"

                debounce="500"
                @update="doSearch"
        />
        <div
                v-if="searchBoxFocused"
        >
            <div v-if="searchQuery && searchQuery.length < 3"  class="dropdown-list">
                <div class="dropdown-content">
                    <p>Introduceți un termen de căutare cu cel puțin 3 litere.</p>
                </div>
            </div>
            <div v-else-if="isSearching" class="dropdown-list">
                <div class="dropdown-content">
                    <p>Căutare...</p>
                </div>
            </div>
            <div v-else-if="searchResults" class="dropdown-list">
                <div v-if="searchResults.products.length === 0"
                     class="dropdown-content">
                    <p>Căutarea nu a întors niciun rezultat!</p>
                </div>

                <div v-else-if="searchResults.products.length > 0" class="dropdown-content">
                    <p class="search-title-text">Rezultate:</p>

                    <div v-for="item in searchResults.products.slice(0, 5)" :key="item.id" @click="unfocus">
                        <a href="#" @click="goToSearchPage">
                            <SearchResult
                                    :title="item.name"
                                    :productCount="1"
                                    :supplierCount="1"
                                    :supplier="item.supplier.name"
                                    :price="item.price ? item.price.price : null"
                                    :currency="item.price ? item.price.currency : null"
                                    :productInfo="item.product_info"
                                    :extraIDs="item.extra_ids"
                            />
                        </a>
                    </div>
                    <p v-if="searchResults.products.length > 5" class="more-results-text">
                        ...și încă {{searchResults.products.length - 5}} rezultate
                    </p>
                </div>

                <div class="dropdown-bottom-content">
                    <b-button size="sm" variant="primary" @click="goToSearchPage">Vezi toate rezultatele</b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchResult from "@/components/search/SearchResult";
    import {mapActions, mapGetters, mapState} from "vuex";
    import {mixin as clickaway} from 'vue-clickaway';
    import axios from "@/utils/axios-instance";

    export default {
        name: "SearchBox",
        mixins: [clickaway],
        components: {SearchResult},
        data() {
            return {
                searchBoxFocused: true,
                inputValue: null,
            }
        },
        computed: {
            ...mapState(['searchResults', 'searchQuery']),
            ...mapGetters(['isSearching']),
        },
        methods: {
            doSearch() {
                this.focus();
                this.search(this.inputValue.trim());
            },
            async saveSearch() {
                await axios.post('search/save-search/', {
                    query: this.searchQuery
                });
            },
            focus() {
                if (this.searchBoxFocused === false) {
                    this.searchBoxFocused = true;
                }
            },
            unfocus() {
                this.searchBoxFocused = false;
            },
            goToSearchPage() {
                if (this.$route.path !== '/search-page') this.$router.push('/search-page');
                this.saveSearch();
                this.unfocus();
            },
            handleEnter(evt) {
                evt.preventDefault();

                if (this.inputValue !== null) this.goToSearchPage();
            },
            ...mapActions(['search']),
        }
    }
</script>

<style scoped>
    .dropdown {
        width: 500px;
    }

    .dropdown-input, .dropdown-selected {
        width: 100% !important;
        padding: 5px 10px;
        border: 1px solid transparent;
        background: #447eb9;
        line-height: 1.5em;
        outline: none;
        border-radius: 8px;
        color: white;
    }

    .dropdown-input:focus {
        background: #fff;
        border-color: #e2e8f0;
        color: black;
    }

    .dropdown-input::placeholder {
        opacity: 0.7;
        color: white;
    }

    .dropdown-input:focus::placeholder {
        color: black;
    }

    .dropdown-list {
        position: absolute;
        width: 100%;
        max-height: 500px;
        margin-top: 4px;
        overflow-y: auto;
        background: #F0F0F0;
        box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
        border-radius: 8px;
        z-index: 2;
    }

    .dropdown-content {
        padding: 10px;
    }

    .dropdown-content div:not(:last-child) {
        margin-bottom: 3px;
    }

    .search-title-text {
        margin-bottom: 5px;
        font-size: 16px;
        font-weight: 600;
    }

    .more-results-text {
        text-align: right;
        font-size: 12px;
        color: grey;
        margin-bottom: 0;
    }

    a, a:hover {
        color: initial;
        text-decoration: none;
    }

    .dropdown-bottom-content {
        position: sticky;
        position: -webkit-sticky;
        bottom: 0;
        background: #e0e0e0a1;

        display: flex;
        justify-content: flex-end;
        align-items: center;

        padding: 10px;
    }
</style>